import axios from "axios";
import { query } from "./api";

// Interceptor para agregar automáticamente el token a cada petición
axios.interceptors.request.use(
    config =>{
        const key = localStorage.getItem("tk"); // Obtiene el token guardado en localStorage
        config.headers!.authorization = `Bearer ${key? key: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.Im9xaWVqb3F3ZWxwZXJyb2FtYXJpbGxvRFNGQUdTREdzZGdkcmhmYmRlMzQyNWxhZHJheWxhZHJhZHFkcXdkIHF3ZG5vbnF3aWV3bnFlcWVxZXRqaGs3NDMi.TCuZwTTp_D6fdJ0fi_C_n79b3FUniZIRQkEBtcfNhd3uAEup6jzvfyoj3LySoeDMpT2_ZuMJBSK4jwEKETBLsA"}`; // Si no hay token, usa el token por defecto
        return config;
    }, 
    error =>{
        return Promise.reject(error); // Devuelve el error de la petición
    }
);

// Crea una nueva votación
export function newPoll(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.post(`${query}/api/votaciones`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Guarda votos en la API
export function addVotes(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.post(`${query}/api/votos`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Actualiza una votación existente
export function updatePoll(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.put(`${query}/api/votaciones`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene todas las votaciones
export function getPolls(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votaciones`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene congresistas filtrando por nombre y bancada
export function getCongressmen(n: string = "", ban: string = "all"): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/congressmen/all/${ban}/${n}`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene un congresista por id
export function getOneCongressmen(id: string = ""): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/congressman/${id}`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene filtros disponibles para congresistas
export function getFilters(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/filters/congressmen`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};


// Obtiene congresistas que ya votaron
export function getCongressmenHasVoted(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votos/congresistas`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene todos los votos
export function getVotos(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene votos desde la versión 2 del endpoint
export function getVotos2(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/v2/votos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene detalles públicos de votos
export function getDetallesVotosPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/detallesvotos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Verifica si hay una votación activa
export function VerificarActiva(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votaciones/activa`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene candidatos desde el endpoint privado
export function getMag(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/candidatos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene candidatos desde el endpoint público
export function getMagPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/candidatos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene resultados por bancada
export function getResultadosBancada(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/bancada/votos`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene información de un congresista por id
export function getCongressman(id: string ): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/v3/congressman/${id}`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};


// Obtiene votos realizados por un congresista
export function ObtenerVotosPorCongresista(id: string ): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votos/congresista/${id}`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Envía información por correo usando el endpoint v2 de votos
export function SendMail(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.post(`${query}/api/v2/votos`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene votos de la votación activa
export function getVotosVotacionActiva(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/votosvotacionactiva`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene votos públicos de la votación activa
export function getVotosVotacionActivaPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/votosvotacionactiva`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene coordenadas básicas de los asientos
export function getSeatCoordenadas(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/seatcoordenadas`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Actualiza coordenadas básicas
export function updateCord(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.put(`${query}/api/updatecord`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene coordenadas completas de asientos
export function getSeatCoordinateComplete(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/seatcoordinatecomplete`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene coordenadas completas desde el endpoint público
export function getSeatCoordinateCompletePublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/seatcoordinatecomplete`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene coordenadas del diagrama desde el endpoint público
export function getSeatCoordinateDiagramaPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/seatcoordinatediagrama`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Actualiza coordenadas completas
export function updateCordComplete(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.put(`${query}/api/updatecordcomplete`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Actualiza coordenadas del diagrama
export function updateCordDiagrama(data:any): Promise<any>{
    return new Promise<any>( resolve => {
        axios.put(`${query}/api/updatecorddiagrama`, data)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene congresistas desde el módulo Shure
export function getCongresistas(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/shure/congresistas`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene congresistas públicos desde el módulo Shure
export function getCongresistasPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/shure/congresistas`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene log de delegados por curul en la conferencia activa
export function getLogDelegatesSeatNumberActiveConference(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/shure/logdelegatesseatnumberactiveconference`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene log público de delegados por curul en la conferencia activa
export function getLogDelegatesSeatNumberActiveConferencePublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/shure/logdelegatesseatnumberactiveconference`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene resultados públicos de votación
export function getVotingResultPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/shure/votingresultpublic`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene resultados públicos recientes de votación
export function getVotingResultRecientesPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/shure/votingresultrecientes`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};


// Obtiene grupos de bancada
export function getGruposBancada(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/api/gruposbancada`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene grupos de bancada públicos
export function getGruposBancadaPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/gruposbancada`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene opciones públicas del módulo magistrados
export function getOpcionesMagistrdosPublic(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/opciones`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};

// Obtiene opciones públicas del módulo SV4 / Shure
export function getOpcionesSV4Public(): Promise<any>{
    return new Promise<any>( resolve => {
        axios.get(`${query}/public/shure/opciones`)
            .then(result => resolve(result) )
            .catch(error => resolve( {data: {successed:false, message: error.message}} ) );
    });
};



/*
CANCEL TOKEN CODE
let cancelTokenArray:{ [key: string]: any } = {};
let cancelToken = cancelTokenArray['getVotingResultRecientesPublic'];
console.dir(cancelTokenArray);
if (cancelToken) {
    cancelToken.cancel("Request cancelado"); 
}
cancelTokenArray['getVotingResultRecientesPublic'] = axios.CancelToken.source();
*/